import React from 'react';
import { TextWithTooltip } from '@ubeya/shared-web/components';
import { RequestTypes } from '@ubeya/shared/hooks/generic/useRequestsTypes';

const NotesRenderer = ({ rowData: { typeId, employeeReason, employeeReasonOther, data } }) => {
  if (typeId === RequestTypes.LEAVE_REQUEST) {
    return <TextWithTooltip>{data?.employeeNote || ''}</TextWithTooltip>;
  }

  return (
    <TextWithTooltip>
      {employeeReason}
      {employeeReasonOther && ` - ${employeeReasonOther}`}
    </TextWithTooltip>
  );
};

export default NotesRenderer;
